import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, Divider, Form, Modal, MultiCascader, SelectPicker, Stack} from 'rsuite';
import {ArrowDownLine} from "@rsuite/icons";
import {mergeCerts} from "../../../../service/adminService";

const viewerModalGridStyle = {
    justifyItems: 'center',
    display: 'grid',
    gridTemplateColumns: '1fr'
};

const CertCleanupModal = (props) => {
    const { open, handleClose, certs } = props;

    const [localState, setLocalState] = useState({});
    const [formattedCerts, setFormattedCerts] = useState([]);

    useEffect(() => {
        let tmp = [];
        certs.forEach((cert) => {
            tmp.push({label: cert.certName, value: cert.id});
        });
        setFormattedCerts(tmp);
    }, [certs]);

    const localClose = useCallback((response) => {
        setLocalState({});
        handleClose(response);
    }, [handleClose]);

    const submitCertMerge = useCallback((isFormValid) => {
        if(!isFormValid) return;
        mergeCerts(localState).then((response) => {
            localClose(response);
        });
    }, [localState, localClose]);

    const isValidMergeRequest = useCallback(() => {
        return localState.sourceCerts?.length > 0 && localState.targetCert !== undefined &&
            localState.targetCert !== null &&
            !localState.sourceCerts?.includes(localState.targetCert);
    }, [localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = useCallback((event) => {
        setLocalState({...localState, ...event});
    }, [localState]);

    return useMemo(() => {
            return (
                <Modal
                    open={open}
                    onClose={() => localClose({})}
                    backdrop="static"
                    size="md"
                >
                    <Modal.Header>
                        <Modal.Title>Certification Cleanup</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack spacing={2} direction='column' alignItems='flex-start'>
                            <p>
                                Merge certifications into another
                            </p>
                            <p>
                                This updates all users of the selected certifications to have the new certification.
                                The old certification is then deleted.
                            </p>
                            <p>
                                <b>A certification cannot both be a source and the target.</b>
                            </p>
                        </Stack>
                        <Divider />
                        <Form
                            style={viewerModalGridStyle}
                            onChange={handleFormChange}
                            onSubmit={submitCertMerge}
                            formValue={localState}
                        >
                            <Form.Group>
                                <Form.ControlLabel>Source Certs</Form.ControlLabel>
                                <Form.Control name="sourceCerts"
                                              menuWidth={600}
                                              menuHeight={300}
                                              accepter={MultiCascader}
                                              data={formattedCerts}
                                              style={{ width: 600 }}
                                />
                            </Form.Group>
                            <ArrowDownLine style={{fontSize: "3em"}}/>
                            <Form.Group>
                                <Form.ControlLabel>Target Cert</Form.ControlLabel>
                                <Form.Control name="targetCert"
                                              accepter={SelectPicker}
                                              data={formattedCerts}
                                              style={{width: 600}}
                                />
                            </Form.Group>
                            {/*Dummy divs for grid css*/}
                            <div />
                            <Button type="submit" appearance="primary" disabled={!isValidMergeRequest()}>
                                Merge
                            </Button>
                            <div />
                        </Form>
                    </Modal.Body>
                </Modal>
            );
        },
        [
            formattedCerts,
            localClose,
            open,
            handleFormChange,
            submitCertMerge,
            localState,
            isValidMergeRequest
        ]
    );
}

export default CertCleanupModal;